import React, { useContext } from "react";
import {
  StyledDivFlex,
  StyledColumn,
  StyledMainContainer,
  StyledContainer,
  StyledButtonsSection,
  StyledProductsSection,
  MaxHeightDiv,
  StyledCircularProgress,
  CircularProgressContainer,
  LastProductSection,
  InnerContainer,
  FlexColumn,
  StyledMuiTextField,
  StyledIconContainer,
  LeftContainer,
  StyledTitle,
  StyledSbtitle,
  TimerSection,
  RightContainer,
} from "./mainPage.styled";
import FilterButton from "@/components/filter-button";

import CustomDropdown from "@/components/custom-dropdown";
import LastProductsContainer from "@/components/last-products-container";
import CatalogGrid from "@/components/catalog-grid";
import Cart from "@/components/cart";

import BusinessIcon from "@mui/icons-material/Business";
import PersonSearchIcon from "@mui/icons-material/PersonSearch";
import SearchIcon from "@mui/icons-material/Search";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import InputAdornment from "@mui/material/InputAdornment";
import ComboPage from "@/pages/comboPage/comboPage";
import CatalogList from "@/components/catalog-list";
import Timer from "@/components/timer";
import InfoCard from "@/components/info-card";
import ConfirmationModal from "@/components/confirmation-modal";
import Alphabet from "@/components/alphabet";
import { accountTypes } from "@/constants";
import amountToFixed from "@/helper/amountToFixed";

import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";

import Box from "@mui/material/Box";
import Header from "@/components/header";
import { useMainPageContext } from "@/contexts/MainPageContext";
import { AppContext } from "@/contexts/AppContext";
import { getTotalAvailableBenefits } from "@/helper/benefitBalance";

const MainPageBody = () => {
  const {
    companies,
    benefits,
    companyAccountBenefits,
    selectedEmployee,
  } = useContext(AppContext);
  const {
    filterProductInputValue,
    users,
    lastProductsOrdered,
    theme,
    goToComboPage,
    selectedComboItem,
    selectedCompany,
    addProductToCart,
    isLoading,
    handleCloseAlert,
    alert,
    setAlert,
    comboSelectedHandler,
    timeLeft,
    categories,
    categoriesSelected,
    toggleCategory,
    clearComboPage,
    addComboToCartHandler,
    changeCompanyHandler,
    setFilterProductInputValue,
    changeEmployeeHandler,
    catalogList,
    selectedCatalogIndex,
    setSelectedCatalogIndex,
    openModal,
    setOpenModal,
    selectedLetter,
    setSelectedLetter,
    selectedAccountTypeId,
    giftCards,
  } = useMainPageContext();
  const renderOption = (props, option) => {
    return (
      <Box component="li" {...props}>
        <StyledTitle variant="subtitle2"> {option.name} </StyledTitle>{" "}
        <StyledSbtitle variant="caption">
          {" "}
          ({option.employeeCode}){" "}
        </StyledSbtitle>
      </Box>
    );
  };
  const isEmployee = selectedAccountTypeId === accountTypes.employee;
  const isCompany = selectedAccountTypeId === accountTypes.company;
  const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });

  const getEmployeeBalanceString = () => {
    const selectedBenefits = isEmployee
      ? benefits
      : isCompany
        ? companyAccountBenefits
        : null;
    if (!selectedBenefits) return "";
    return `RD$ ${amountToFixed(
      getTotalAvailableBenefits(selectedBenefits, isEmployee ? giftCards : []),
      2,
    )}`;
  };

  return (
    <>
      <Header />

      <StyledMainContainer>
        <ConfirmationModal
          balance={getEmployeeBalanceString()}
          open={openModal}
          setOpen={setOpenModal}
        />
        <Snackbar
          open={alert.open}
          autoHideDuration={alert.duration}
          onClose={handleCloseAlert}
        >
          <Alert
            onClose={handleCloseAlert}
            severity={alert.severity}
            sx={{ width: "100%" }}
          >
            {alert.message}
          </Alert>
        </Snackbar>
        <InnerContainer>
          {goToComboPage ? (
            <ComboPage
              setAlert={setAlert}
              clearComboPage={clearComboPage}
              catalogId={catalogList[selectedCatalogIndex]?.id}
              addComboToCartHandler={addComboToCartHandler}
              selectedComboItem={selectedComboItem}
            />
          ) : (
            <MaxHeightDiv container spacing={3}>
              <LeftContainer>
                <FlexColumn>
                  <StyledColumn>
                    <StyledDivFlex>
                      <StyledContainer style={{ width: "100%" }}>
                        <CustomDropdown
                          onChange={(e, newValue) => {
                            changeCompanyHandler(newValue);
                          }}
                          value={selectedCompany}
                          color="#6ec4e8"
                          label="Seleccione una empresa"
                          options={companies}
                          noOptionsText="Ninguna empresa encontrada"
                          labelPropName="companyName"
                          Icon={BusinessIcon}
                        />
                      </StyledContainer>
                      <StyledContainer>
                        <CustomDropdown
                          renderOption={renderOption}
                          onChange={(e, newValue) => {
                            changeEmployeeHandler(newValue);
                          }}
                          value={selectedEmployee}
                          color={theme.palette.secondary.main}
                          label="Introduzca Nombre o Código de empleado"
                          options={users}
                          virtualScroll={users.length > 30}
                          noOptionsText="Ningun empleado encontrado"
                          labelPropName="name"
                          Icon={PersonSearchIcon}
                        />
                      </StyledContainer>
                    </StyledDivFlex>
                    <StyledDivFlex>
                      <StyledContainer>
                        <StyledMuiTextField
                          value={filterProductInputValue}
                          onChange={(e) =>
                            setFilterProductInputValue(e.target.value)
                          }
                          label="Introduzca Nombre, Palabras claves o SKU"
                          InputLabelProps={{
                            style: { color: theme.palette.primary.main },
                          }}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <StyledIconContainer
                                  color={theme.palette.primary.main}
                                >
                                  <SearchIcon
                                    style={{ width: "32px", height: "32px" }}
                                  />
                                </StyledIconContainer>
                              </InputAdornment>
                            ),
                            autoComplete: "off",
                          }}
                        />
                      </StyledContainer>
                      <StyledContainer>
                        {catalogList?.length > 0 && (
                          <StyledButtonsSection>
                            <StyledDivFlex>
                              {categories.map((category) => (
                                <FilterButton
                                  key={category.name}
                                  color={category.color}
                                  label={category.name}
                                  selected={categoriesSelected[category.name]}
                                  onClickHandler={toggleCategory}
                                />
                              ))}
                            </StyledDivFlex>
                          </StyledButtonsSection>
                        )}
                      </StyledContainer>
                    </StyledDivFlex>

                    {lastProductsOrdered?.length > 0 && (
                      <LastProductSection>
                        <LastProductsContainer
                          color={theme.palette.secondary.main}
                          label="Últimos productos ordenados"
                          lastProducts={lastProductsOrdered}
                          comboSelectedHandler={comboSelectedHandler}
                          productSelectedHandler={addProductToCart}
                        />
                      </LastProductSection>
                    )}

                    <CatalogList
                      selectedCatalogIndex={selectedCatalogIndex}
                      catalogNameList={catalogList.map(
                        (catalog) => catalog.name,
                      )}
                      setSelectedCatalogIndex={setSelectedCatalogIndex}
                    />
                  </StyledColumn>

                  <TimerSection>
                    <Timer title="Tiempo Restante" time={timeLeft} />
                  </TimerSection>

                  <Alphabet
                    selectedLetter={selectedLetter}
                    setSelectedLetter={setSelectedLetter}
                  />

                  <StyledProductsSection>
                    {isLoading ? (
                      <CircularProgressContainer>
                        <StyledCircularProgress />
                      </CircularProgressContainer>
                    ) : !selectedEmployee.name ? (
                      <InfoCard
                        Icon={PersonSearchIcon}
                        color={theme.palette.secondary.main}
                        text={"Busca el usuario a quien deseas ordenarle"}
                      />
                    ) : catalogList?.length === 0 ? (
                      <InfoCard
                        Icon={HighlightOffIcon}
                        color={theme.palette.secondary.main}
                        text={"¡Este catálogo está inactivo!"}
                      />
                    ) : (
                      <CatalogGrid
                        comboColor="#6ec4e8"
                        productColor="#acb4b9"
                      />
                    )}
                  </StyledProductsSection>
                </FlexColumn>
              </LeftContainer>

              <RightContainer>
                <Cart
                  benefits={isEmployee ? benefits : companyAccountBenefits}
                  employeeBalance={getEmployeeBalanceString()}
                  buttonText="Procesar"
                />
              </RightContainer>
            </MaxHeightDiv>
          )}
        </InnerContainer>
      </StyledMainContainer>
    </>
  );
};

export default MainPageBody;
